
<template>
    
        <mars-view id="consultCard" class="consult-card" data-serverid="17291" data-area="recommend_xiansuo_show" @click.native="clickConsult"><mars-view class="title">已提供咨询服务</mars-view><mars-view class="icon"></mars-view><mars-view v-if="consultCnt" class="count"><span class="baidufont num">{{ consultCnt }}</span>次</mars-view><mars-view class="btn">咨询专线</mars-view><mars-view class="sub-title">最快三分钟获得律师专业解答</mars-view></mars-view>
    
</template>

<script>
// 咨询卡
import log from '../../../static/utils/ubcLog';
export default {
  name: 'consultCard',
  props: {
    consultCnt: {
      type: Number,
      default: 0
    }
  },
  methods: {
    /**
     * 点击咨询专线按钮
     */

    clickConsult() {
      // 咨询卡片点击
      log.send && log.send({
        serverId: 17291,
        area: 'recommend_xiansuo_click',
        action: 'click'
      });
      this.$emit('clickConsult');
    }
  }
};
</script>

<style scoped>
.consult-card {
  width: 1.96rem;
  box-sizing: border-box;
  border-radius: 0.09rem;
  border: 1px solid #fff;
  padding: 0.2rem 0.1rem;
  background: linear-gradient(183deg, #e8effc 2.42%, #fff 26.85%);
}
.consult-card .title {
  font-family: PingFang SC;
  color: #1e1f24;
  font-size: 0.16rem;
  font-weight: 500;
  line-height: 1;
}
.consult-card .icon {
  width: 0.49rem;
  height: 0.49rem;
  margin: 0.3rem auto 0;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/note/call.png') no-repeat center center / 100% 100%;
}
.consult-card .count {
  margin-top: 0.14rem;
  color: #1e1f24;
  font-size: 0.18rem;
  font-weight: 600;
  line-height: 0.2rem;
  letter-spacing: 0.6px;
  font-family: PingFang SC;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.consult-card .count .num {
  font-size: 0.22rem;
  font-weight: 500;
}
.consult-card .btn {
  margin-top: 0.3rem;
  background: #05f;
  height: 0.32rem;
  width: 1.76rem;
  color: #fff;
  font-size: 0.14rem;
  font-weight: 500;
  font-family: PingFang SC;
  line-height: 0.32rem;
  text-align: center;
  border-radius: 0.6rem;
}
.consult-card .sub-title {
  margin-top: 0.12rem;
  color: #495266;
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 1;
  text-align: center;
}

</style>
